import { ActivatedRouteSnapshot } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'lotto',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../lottery/app/src/lottery.routes').then((t) => t.LottoRoutesModule),
            canMatch: [(route: ActivatedRouteSnapshot) => clientConfigAppGuard(route)],
            canActivate: [productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.LOTTO },
        },
    ],
};

export default routes;
